import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { ConnectedRouter } from 'connected-react-router';
import { history } from '../store';
import PAGES from '../pages';
import { AnimatePresence } from 'framer-motion';

const useStyles = makeStyles(theme => ({
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

export default function RouterContainer() {
  const classes = useStyles();
  return (
    <main className={classes.content}>
      <div className={classes.toolbar} />
      <ConnectedRouter history={history}>
        <Route
          render={({ location }) => (
            <AnimatePresence exitBeforeEnter>
              <Switch location={location} key={location.pathname}>
                {PAGES.map(page => (
                  <Route
                    exact
                    key={page.path}
                    path={page.path}
                    component={page.component}
                  />
                ))}
                {/* <Redirect to='/' /> */}
              </Switch>
            </AnimatePresence>
          )}
        />
      </ConnectedRouter>
    </main>
  );
}
